// DemoConstants.js
import imageFemale1 from "../../Assets/Images/Demos/female-1.png";
import imageFemale2 from "../../Assets/Images/Demos/female-2.png";
import imageMale1 from "../../Assets/Images/Demos/male-1.png";

import waveCard1 from "../../Assets/Images/Demos/waves1.png";
import waveCard2 from "../../Assets/Images/Demos/waves2.png";
import waveCard3 from "../../Assets/Images/Demos/waves3.png";

export const SOUNDWAVE_CARDS = [waveCard1, waveCard2, waveCard3];

// Character data for voice selection (original method)
export const CHARACTERS = [
    {
        id: "Amara-en-2025-03-13",
        name: "Amara",
        provider: "custom"
    },
    {
        id: "Sophia-en-2025-03-18",
        name: "Sophia",
        provider: "custom"
    },
    {
        id: "Natalie-en-2025-03-17",
        name: "Natalie",
        provider: "custom"
    },
    {
        id: "Gabriel-en-2025-03-17",
        name: "Gabriel",
        provider: "custom"
    },
    {
        id: "Marcus-en-2025-03-17",
        name: "Marcus",
        provider: "custom"
    },
    {
        id: "Ethan-en-2025-03-17",
        name: "Ethan",
        provider: "custom"
    }
];

// Enhanced character data with embedded emotions and accents (new method)
// The UI remains the same, but this data structure allows for more precise voice selection
export const ENHANCED_CHARACTERS = [
    {
        id: "Maria",
        name: "Maria",
        image: imageFemale1,
        provider: "custom",
        emotions: {
            "Neutral": "C1e5HZV1QQzXFpLjjiGE",
            // "Joy-Celebration": "MfouYoLixCcBVoIV6I2F",
            "sadness": "gNDuiH0X1WwInKs5rgsj",
            "Anger": "P7u8TcjIxdgo4DZpCUZb",
            "fear": "VZj7Hb9sGsa44eehQsJ8",
        },
        accents: {
            "German-Accent-v1": "German",
        }
    },
    {
        id: "Halley",
        name: "Halley",
        image: imageFemale2,
        provider: "custom",
        emotions: {
            "Neutral": "pgn2NjVNcvGxyNMqsIUj",
            "Joy-Celebration": "aBUhC4fzFoBbYsOYcZWL",
            // "sadness": "3qJnVgBtK7wY6pXzH2mS",
            // "Anger": "fL2cRnQ9yJvX4sWbG7tP",
            // "fear": "kM5xZdV3nTpL8bNrS6gH",
        },
        accents: {
            "American-Accent-v1": "American",
        }
    },
    {
        id: "Liliane",
        name: "Liliane",
        image: imageFemale1,
        provider: "custom",
        emotions: {
            "Neutral": "tEbISw96J64xYqy636NM",
            "Joy-Celebration": "aGX7Ip5BXsPsXSAPNNRG",
            "sadness": "JT1tUCuU9FOtX0R0S2KI",
            "Anger": "YQSwv1umY7k4kqu2orJ3",
            "fear": "SuLNMX2NnBsyLAYGUgKR",
        },
        accents: {
            "French-Accented English v2": "French",
        }
    },
    {
        id: "Liz",
        name: "Liz",
        image: imageFemale2,
        provider: "custom",
        emotions: {
            "Neutral": "UR0VA5ps28hQ0HcL2DC0",
            "Joy-Celebration": "kndLneHRNqCStH48pmnl",
            "sadness": "hJfN0N4hEhMzk6FbIImL",
            "Anger": "cIF0D3uqEQpKFC5PDhby",
            "fear": "dRXsCPunTHlKoE2g4Gko",
        },
        accents: {
            "Lat-Am-Spanish-v1": "Spanish",
        }
    },
    ////Males
    {
        id: "Jonathan",
        name: "Jonathan",
        image: imageMale1,
        provider: "custom",
        emotions: {
            "Neutral": "upqEl7KhPDbvzRGqyj4g",
            "Joy-Celebration": "MfouYoLixCcBVoIV6l2F",
            "Sadness": "PowwTpXA7gDTzXJ3F75H",
            "Anger": "COcwQcAJF3Mf5CnRfck4",
            "Fear": "vE1W8Usk6q7Yhz9Qfo3M",
        },
        accents: {
            "American-Accent-v1": "American",
        }
    },
    {
        id: "Leonardo",
        name: "Leonardo",
        image: imageMale1,
        provider: "custom",
        emotions: {
            "Neutral": "BImrfM83hK4eQ7uTUuHo",
            "Joy-Celebration": "kSDEtteYs9eZZY8xfoN0",
            "Sadness": "19v18PHdcGcWRqiBcmAp",
            "Anger": "csWTVsI8oGuF1MfOGy5d",
            "Fear": "7faVrIrB19YGqKHYwlI6",
        },
        accents: {
            "Brazilian Portuguese-Accented English v1": "Brazilian",
        }
    },
    {
        id: "Dew",
        name: "Dew",
        image: imageMale1,
        provider: "custom",
        emotions: {
            "Neutral": "wfaN4LsOpL4F673vl6Mm",
            "Joy-Celebration": "FwJoZrGxTWRrxrdJAysZ",
            "Sadness": "sAxIQy9f6cDQsNAekl4S",
            "Anger": "yjmNOFbhIlOWW1uLShFH",
            "Fear": "De9AXLNzC2br13akWFyb",
        },
        accents: {
            "Thai-Inflected-v1": "Thailand",
        }
    },
    {
        id: "Robin",
        name: "Robin",
        image: imageMale1,
        provider: "custom",
        emotions: {
            "Neutral": "OWW6tDLYK9VF7OnqD9Ar",
            "Joy-Celebration": "rj537Smp9LESgGFkR0FG",
            "Sadness": "IGmCi9c5y9pxbkXkvlFI",
            "Anger": "G5HmJQGPClBYy7xTJ5x8",
            "Fear": "Igr641gtpyMy7l4hrUlx",
        },
        accents: {
            "Brazilian Portuguese-Accented English v1": "US_Male_Standard",
        }
    },
];

// Emotions with positions for the EmotionWheel component (remains the same)
export const EXPANDED_EMOTIONS = [
    // Top half (Aroused)
    { id: "Fear-Terror", name: "Fear", position: { x: 75, y: 95 } },
    { id: "Surprise-Delight", name: "Surprise", position: { x: 170, y: 95 } },
    { id: "Anger-Rage", name: "Anger", position: { x: 45, y: 135 } },
    { id: "Shock", name: "Shock", position: { x: 120, y: 135 } },
    { id: "Excitement-Enthusiasm", name: "Excitement", position: { x: 180, y: 135 } },
    { id: "Passion", name: "Passion", position: { x: 225, y: 135 } },
    { id: "Grief-Hysteria", name: "Grief", position: { x: 75, y: 175 } },
    { id: "Joy-Celebration", name: "Joy", position: { x: 210, y: 175 } },

    // Middle section
    { id: "Cold-Anger-Sarcasm", name: "Cold", position: { x: 60, y: 225 } },
    // { id: "Indifference", name: "Indifference", position: { x: 120, y: 225 } },
    { id: "Contentment", name: "Contentment", position: { x: 180, y: 225 } },
    { id: "Fondness", name: "Fondness", position: { x: 225, y: 225 } },

    // Bottom half (Unaroused)
    { id: "Sadness", name: "Sadness", position: { x: 75, y: 275 } },
    { id: "Depression-Despair", name: "Despair", position: { x: 120, y: 275 } },
    { id: "Sleepiness", name: "Sleepiness", position: { x: 180, y: 275 } },
    { id: "Serenity-Peacefulness", name: "Serenity", position: { x: 210, y: 275 } },

    // Default neutral state
    // { id: "Neutral", name: "Neutral", position: { x: 150, y: 190 } }
    { id: "Indifference", name: "Indifference", position: { x: 120, y: 225 } },
];

// Countries with positions for the CountrySelector component (remains the same)
export const COUNTRIES = [
    { id: 'French-Accent', name: 'French Accent', position: { x: 150, y: 140 } },
    { id: 'German-Accent', name: 'German Accent ', position: { x: 170, y: 130 } },
    { id: 'American-Accent-v1', name: 'American Accent', position: { x: 70, y: 140 } },
    { id: 'Lat-Am-Spanish-v1', name: 'Latin American Spanish Accent', position: { x: 55, y: 160 } },
    { id: 'Brazilian-Portuguese-v1', name: 'Brazilian Portuguese Accent', position: { x: 100, y: 210 } },
    { id: 'Thai-Inflected-v1', name: 'Thai Accent', position: { x: 250, y: 150 } },
    // { id: 'Swedish-Accent', name: 'Swedish Accent', position: { x: 250, y: 150 } },
];

// Wheel configuration settings (remains the same)
export const WHEEL_CONFIG = {
    centerX: 150,
    centerY: 190,
    radius: 120
};